export const fundChartDataTransformer = (input) => {
  const data = input
    ?.map((item) => Number(item.final_price))
    .filter((item) => item !== null);
  return data;
};

export const handleFundEfficiencyTitle = (data, translate) => {
  const { annual_return, semi_yearly, quarter_return, monthly_return } = data;

  if (annual_return !== null) {
    return translate("home-page.fund-efficiency", { time: "سال" });
  } else if (annual_return === null && semi_yearly !== null) {
    return translate("home-page.fund-efficiency", { time: "شش ماه" });
  } else if (
    annual_return === null &&
    semi_yearly === null &&
    quarter_return !== null
  ) {
    return translate("home-page.fund-efficiency", { time: "سه ماه" });
  } else if (
    annual_return === null &&
    semi_yearly === null &&
    quarter_return === null &&
    monthly_return !== null
  ) {
    return translate("home-page.fund-efficiency", { time: "یک ماه" });
  } else {
    return translate("home-page.fund-efficiency", { time: "روز" });
  }
};

export const handleRefreshHomeApi = async (queryClient, refetchHomeData) => {
  queryClient.clear();
  await refetchHomeData();
};
